<div i18n class="row space-between selectarea">
  <h2>Agents</h2>
  <div class="row gap-8">
    <rr-btn iconStart="add" type="Secondary" (click)="newAgent()"
      >new Agent</rr-btn
    >
  </div>
</div>
<div class="col agentarea w100">
  <div
    class="row gap-16 details w100 align-center"
    *ngFor="let agent of agents"
    (click)="editAgent(agent)"
  >
    <img
      [src]="frontendserverurl + '/public/llmavatars/' + agent.avatar"
      alt=""
    />
    <div class="col">
      <h4 class="color-strong">{{ agent.name }}</h4>
      <div class="tiny">
        {{ agent.industryId | getIndustryNameById | async }}
      </div>
    </div>
    <div class="status tiny">{{ agent.status }}</div>
    <div class="llm tiny">{{ agent.llmId.toUpperCase() }}</div>
  </div>
</div>
